let lockCount = 0
let scrollY = 0

export function lockScroll() {
  if (lockCount === 0) {
    scrollY = window.scrollY
    document.documentElement.classList.add("modal-open")
    document.body.classList.add("modal-open")
    document.body.style.top = `-${scrollY}px`
  }
  lockCount += 1
}

export function unlockScroll() {
  if (lockCount === 0) return

  lockCount -= 1
  if (lockCount > 0) return

  document.documentElement.classList.remove("modal-open")
  document.body.classList.remove("modal-open")
  document.body.style.top = ""
  window.scrollTo(0, scrollY)
}

export function forceUnlockScroll() {
  lockCount = 0
  document.documentElement.classList.remove("modal-open")
  document.body.classList.remove("modal-open")
  document.body.style.top = ""
}
